















































































import {Component, Vue} from "vue-property-decorator";
import {State, Action, Getter, Mutation} from 'vuex-class'
import SFKnob from '@/components/SFKnob.vue';
import {ProgressFooter, SFPreloader} from '@/components';

import t from '@/i18n/translations';

import report from '@/api/report';

const formNamespace = 'form';
const reportNamespace = 'reports';
const progressNamespace = 'progress';
const ns_user = { namespace: 'user' };

@Component({
    components: {
        SFKnob,
        ProgressFooter,
        SFPreloader
    },
})
export default class ReportSummary extends Vue {
    @Action('fetchReport', {namespace: reportNamespace}) fetchReport: any;
    @Action('postForm', {namespace: formNamespace}) postForm: any;
    @Getter('getForm', {namespace: formNamespace}) getForm: any;
    @Getter('getGeneralInformationAnswers', {namespace: formNamespace}) getGeneralInformationAnswers: any;
    @Getter('getAnswers', {namespace: formNamespace}) getAnswers: any;
    @Getter('getSummary', {namespace: reportNamespace}) getSummary: any;
    @Getter('getUserInfo', ns_user) getUserInfo: any;
    @Mutation('toggleProgress', {namespace: progressNamespace}) toggleProgress: any;

    selectedBranchID: string = '';
    i18n = t['nl'];

    mounted(): void {
        this.selectedBranchID = this.$route.params.id;
        this.toggleProgress('summary');
    }

    getAnswer(questionId: number): string {
        const aId = this.getAnswers[questionId - 1].answerId;
        let aContent = '';

        this.getForm.forEach(el => {
            el.fields.forEach(field => {
                field.answers.forEach(answer => {
                    if (answer.id === aId) {
                        aContent = answer.answerDescription;
                    }
                })
            })
        });

        return aContent;
    }

    onHandleSubmit() {
        this.postForm();
    }
}
